module.exports = __webpack_public_path__ + "static/assets/05e9c069d478b9e056e35f04e7dedf64.svg";